(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fsc-wedding-suites"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-fsc-story-toggle]');
    if (!toggle) return;

    var section = toggle.closest('.fsc-ws');
    var panel = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!section || !panel) return;

    var willOpen = toggle.getAttribute('aria-expanded') !== 'true';
    section.querySelectorAll('[data-fsc-story-toggle]').forEach(function (otherToggle) {
      otherToggle.setAttribute('aria-expanded', 'false');
      otherToggle.textContent = otherToggle.dataset.openLabel;
    });
    section.querySelectorAll('.fsc-ws__story').forEach(function (otherPanel) {
      otherPanel.hidden = true;
    });

    if (willOpen) {
      toggle.setAttribute('aria-expanded', 'true');
      toggle.textContent = toggle.dataset.closeLabel;
      panel.hidden = false;
    }
  });

  } catch(e) { console.error(e); }
})();
})();
